/*
 * Summary Messages
 *
 * This contains all the text for the Summary component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
    ok: {
        id: 'app.components.Summary.header',
        defaultMessage: 'Ok'
    },
    ViewSummary: {
        id: 'app.components.Summary.ViewSummary',
        defaultMessage: 'View summary'
    },
    back: {
        id: 'app.components.Summary.back',
        defaultMessage: 'Back'
    },
    print: {
        id: 'app.components.Summary.print',
        defaultMessage: 'Print'
    }
});



// WEBPACK FOOTER //
// ./app/components/upload-summary/messages.js